// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import {
  MintRequest,
  MintRequest_Cancel,
} from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Mint';
import { ContractId } from '@daml/types';
import { ERR_CAN_MINT, SUC_CAN_MINT } from '../../../../utils/strings';

interface Args {
  mintRequestCid: ContractId<MintRequest>;
}

export const useCancelMintRequest2Step = () => {
  const { submit: cancelMintRequest } = useExerciseSubmission(
    MintRequest.MintRequest_Cancel,
    SUC_CAN_MINT,
    ERR_CAN_MINT,
  );

  return async (args: Args) => {
    const { mintRequestCid } = args;

    const payload: MintRequest_Cancel = {};

    const disclosedContracts: never[] = [];

    await cancelMintRequest({
      cid: mintRequestCid,
      argument: payload,
      meta: {
        disclosedContracts,
      },
    });
  };
};
